/**
 * Sticky Mobile Accordion Navigation Handler
 * Uses Intersection Observer API to detect active sections for product.with-color-swatches template
 */
(function() {
  $(document).ready(function() {
    if (typeof IntersectionObserver === 'undefined') {
      console.warn('Intersection Observer not supported');
      return;
    }
    
    var $stickyMenu = $("#shopify-section-sticky-mobile .mn-hd");
    var $stickyLinks = $stickyMenu.find("a");
    var observer = null;
    var observedSections = {};
    var currentActiveSection = null;
    var updateTimer = null;
    var debounceDelay = 150;
    
    function setActiveLink($link) {
      $stickyMenu.find("li").removeClass("_active");
      $link.parent().addClass("_active");
    }
    
    /**
     * Updates active menu item based on section ID
     */
    function updateActiveMenu(sectionId) {
      if (!sectionId) return;
      
      var $targetLink = $stickyLinks.filter('[href="#' + sectionId + '"]');
      
      if ($targetLink.length) {
        setActiveLink($targetLink);
        currentActiveSection = sectionId;
      }
    }
    
    /**
     * Calculates active section using intersection ratio and distance from viewport center
     */
    function calculateActiveSection() {
      var activeSectionId = null;
      var bestScore = -1;
      var viewportCenter = window.innerHeight / 2 + 150;
      
      for (var sectionId in observedSections) {
        var data = observedSections[sectionId];
        
        if (!data.isIntersecting || data.intersectionRatio === 0) {
          continue;
        }
        
        var sectionCenter = data.boundingClientRect.top + (data.boundingClientRect.height / 2);
        var distanceFromCenter = Math.abs(sectionCenter - viewportCenter);
        var score = (data.intersectionRatio * 100) - (distanceFromCenter / 20);
        
        if (score > bestScore) {
          bestScore = score;
          activeSectionId = sectionId;
        }
      }
      
      if (activeSectionId && activeSectionId !== currentActiveSection) {
        updateActiveMenu(activeSectionId);
      }
    }
    
    /**
     * Intersection Observer callback - tracks visibility data for all sections
     */
    function handleIntersection(entries) {
      entries.forEach(function(entry) {
        var sectionId = entry.target.id;
        
        if (!sectionId) return;
        
        observedSections[sectionId] = {
          element: entry.target,
          isIntersecting: entry.isIntersecting,
          intersectionRatio: entry.intersectionRatio,
          boundingClientRect: entry.boundingClientRect
        };
      });
      
      clearTimeout(updateTimer);
      updateTimer = setTimeout(calculateActiveSection, debounceDelay);
    }
    
    /**
     * Initializes Intersection Observer and observes all target sections
     */
    function initializeObserver() {
      var observerOptions = {
        root: null,
        rootMargin: "150px 0px -50% 0px",
        threshold: [0, 0.25, 0.5, 0.75, 1.0]
      };
      
      observer = new IntersectionObserver(handleIntersection, observerOptions);
      
      $stickyLinks.each(function() {
        var $link = $(this);
        var href = $link.attr("href");
        
        if (!href || href.indexOf("#") !== 0) return;
        
        var sectionId = href.substring(1);
        var $target = $(href);
        
        if ($target.length && $target[0].id) {
          observer.observe($target[0]);
        }
      });
      
      setTimeout(calculateActiveSection, 200);
    }
    
    /**
     * Re-observes a section (for accordion content that becomes visible)
     */
    function reObserveSection(href) {
      if (!observer) return;
      
      var $target = $(href);
      if ($target.length && $target[0].id) {
        observer.observe($target[0]);
      }
    }
    
    /**
     * Click handler - sets active state immediately and handles accordion navigation
     */
    function handleClick(e) {
      var $link = $(this);
      var href = $link.attr("href");
      
      setActiveLink($link);
      
      if (href && href.indexOf("#") === 0) {
        currentActiveSection = href.substring(1);
        window.location.hash = href;
      }
      
      var tabValue = $link.data("accordionValue");
      if (!tabValue) {
        return;
      }
      
      e.preventDefault();
      
      var $target = $(href);
      if (!$target.length) {
        return;
      }
      
      $('.tab-js .ct > .tab[data="' + tabValue + '"]').trigger('click');
      
      // Stop conflicting animations immediately
      $('html,body').stop(true, false);
      
      // Wait for accordion to open, then scroll (100ms initial + 150ms for accordion = 250ms total)
      setTimeout(function() {
        if ($target.is(':hidden') && $target.css('display') === 'none') {
          return;
        }
        
        var targetElement = $target[0];
        if (!targetElement) {
          $('html,body').animate(
            { scrollTop: $target.offset().top - 100 },
            400,
            function() {
              reObserveSection(href);
            }
          );
          return;
        }
        
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        
        // Re-observe after scroll completes (smooth scroll duration ~500ms)
        setTimeout(function() {
          reObserveSection(href);
        }, 500);
      }, 250);
    }
    
    setTimeout(function() {
      $(document).off("scroll", onScroll);
      $stickyLinks.off("click");
      $stickyLinks.on("click", handleClick);
      initializeObserver();
    }, 200);
    
    $(window).on("beforeunload", function() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    });
  });
})();

